<template>
  <div class="wg-row wg-xs-12">
    <div class="wg-col wg-xs-12 wg-lg-7">
      <!-- Custom component for set-place-flow, if present -->
      <component
          v-if="customComponent"
          :is="customComponent"
          :projectId="project.idWorldProject"
          @done="customComponent = null"
      ></component>
      <h1 class="com-anm22-page-title">
        {{ $anm22.strLang(lang, 'Project place', 'Luogo del progetto') }}
      </h1>
      <div v-if="place" class="wg-row">
        <div class="wg-col wg-xs-12">
          <w-g-world-place-container :place="place" :assoc="getAssoc(place)" :extended="true"></w-g-world-place-container>
        </div>
      </div>
      <div class="vertical-height-div" style="height:15px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="margin-top:5px;">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 'Default timezone', 'Fuso orario predefinito') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select class="com-anm22-app-select" v-model="timezone">
            <option default disabled value="">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option 
                v-for="(timezone, key, index) in $anm22.tableClasses.worldTimezone().getAll()"
                :key="'timezone-'+index"
                :value="key">{{ timezone[lang] }}</option>
          </select>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6" style="margin-top:5px;">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, 'Default currency', 'Valuta predefinita') }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select class="com-anm22-app-select" v-model="currencyType">
            <option default disabled value="">{{ $anm22.strLang(lang, 'Select one', 'Seleziona') }}</option>
            <option 
                v-for="(currencyType, key, index) in $anm22.tableClasses.worldCurrencyType().getAll()"
                :key="'currency-'+index"
                :value="key">{{ currencyType[lang] }}</option>
          </select>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Save', 'Salva')" 
          @click="saveProject">
      <div class="vertical-height-div" style="height:40px;"></div>
      <template v-if="!offline">
        <div v-if="place" class="wg-row">
          <div class="wg-col wg-xs-12">
            <div class="com-anm22-app-text-l">
              {{ $anm22.strLang(lang, 'Change place', 'Cambia luogo') }}
            </div>
          </div>
        </div>
        <div v-else class="wg-row">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, 'Select place', 'Seleziona luogo') }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div v-if="(assocs.length === 0) || (place && (assocs.length === 1) && (assocs[0].place === place.idWorldPlace))" class="wg-row">
          <div class="com-anm22-app-text-l" style="padding-bottom:50px;">
            {{ $anm22.strLang(lang, 'No place to select', 'Nessun luogo selezionabile') }}
          </div>
        </div>
        <template v-else>
          <div 
              v-for="(a, index) in assocs.filter(a => this.place ? a.place !== this.place.idWorldPlace : true)"
              :key="'wp'+index"
              class="wg-row"
              style="cursor:pointer;"
              @click="setPlace(a.place)">
            <img 
                :src="placeIcon(a)"
                :title="placeLabel(a)"
                class="com-anm22-app-img-fixed-height-s com-anm22-round"
            >
            <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
            <div class="com-anm22-app-text-m">
                {{ placeLabel(a) }}
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
          </div>
        </template>
      </template>
      <!-- <div class="vertical-height-div" style="height:20px;"></div> -->
      <!-- <a href="https://www.anm22.it/app/work/viewPricings.php">
        <input 
            type="button" 
            :value="$anm22.strLang(lang, 'Manage customers', 'Gestisci clienti')">
      </a> -->
    </div>
    <div class="wg-col wg-xs-none wg-lg-5 project-manage-help-box">
      <img :src="$anm22.icons.getWorldIcon('placeBlack')" />
      <div style="padding:0 20px">
        <strong>{{$anm22.strLang(lang, 'Set place', 'Imposta luogo')}}</strong><br />
        {{$anm22.strLang(lang, '', 'Indica dove si svolge il progetto, in modo da adattare il fuso orario e la valuta per le spese.')}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGWorldPlaceContainer from '../../../../../../world/spa/components/WGWorldPlaceContainer.vue';

export default {
  props: {
    data: Object
  },
  data() {
    return {
      customComponent: null,
      loading: false
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      offline: state => state.offline.isOffline
    }),
    project() {
      return this.$store.getters['projects/get'](this.data.project.idWorldProject);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter(e => this.project.developers.includes(e.work))
        .map(e => this.$store.getters["licenses/getByWork"](e.work))
        .filter(l => l);
    },
    place() {
      return this.project.place ? this.$store.getters['places/get'](this.project.place) : null;
    },
    assocs() {
      let assocs = [];
      this.project.developers.forEach(w => {
        assocs = assocs.concat(
          this.$store.getters['workPlaceAssocs/getByWork'](w)
        );
      });
      this.project.customers.forEach(c => {
        assocs = assocs.concat(
          this.$store.getters['contactPlaceAssocs/getByContact'](c)
        );
      });
      return assocs;
    },
    timezone: {
      get() {
        if(this.project && this.project.timezone) {
          return this.project.timezone;
        } else {
          if(!this.loading && this.assocs.length > 0) {
            const place = this.$store.getters['places/get'](this.assocs[0].place);
            return place.timezone;
          } else {
            const objs = this.$anm22.tableClasses.worldTimezone().getAll();
            return Object.keys(objs)[0];
          }
        }
      }, 
      set(val) {
        this.project.timezone = val;
      }
    },
    currencyType: {
      get() {
        if(this.project && this.project.currencyType) {
          return this.project.currencyType;
        } else {
          if(!this.loading && this.assocs.length > 0) {
            const place = this.$store.getters['places/get'](this.assocs[0].place);
            return place.currencyType;
          } else {
            const objs = this.$anm22.tableClasses.worldCurrencyType().getAll();
            return Object.keys(objs)[0];
          }
        }
      }, 
      set(val) {
        this.project.currencyType = val;
      }
    }
  }, 
  methods: {
    getAssoc(place) {
      return this.assocs.find(a => a.place === place.idWorldPlace);
    },
    placeIcon(a) {
      if(a.work) {
        return this.$anm22.getObjIcon(this.$store.getters['works/get'](a.work), 'workDefault');
      } else {
        return this.$anm22.getContactIcon(this.$store.getters['contacts/get'](a.contact), this.$store);
      }
    },
    placeLabel(a) {
      const place = this.$store.getters['places/get'](a.place);
      if(place) {
        return place.name + ', ' + this.$anm22.getAddressFromPlace(this, place);
      } else {
        return '';
      }
    },
    saveProject() {
      this.$http
        .post('/project/edit/', {
          project: this.project
        }, {
          withCredentials: true
        })
        .then(response => {
          //Salvo con localForage
          this.$store.dispatch('projects/update', {
            vlf: this.$vlf('projects'),
            objs: response.data.projects
          })
          .then(() => {
            this.$Progress.finish();
          })
          .catch(error => console.log(error));
        })
        .catch(error => {
          /* Salvo l'oggetto nel db */
          Promise.all([
            this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'),
              objs: response.data.projects
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "WorldProject",
              _table: "projects",
              mode: 'edit',
              type: 'obj',
              obj: this.project
            }),
            // this.$anm22.saveSyncTuple(this, 'WorldProject', 'edit', this.project)
          ])
          .then(result => {
            this.$Progress.finish();
          })
          .catch(error => console.log(error));
        });
    },
    setPlace(placeId) {
      this.$http
        .post("/project/place/", {
          projectId: this.project.idWorldProject,
          placeId: placeId
        }, {
          withCredentials: true
        })
        .then(response => {
          //update di projects e workPlaceAssocs
          this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'),
              objs: response.data.projects
          })
          .then(() => {
            //Customizzazione setPlace in config di licenza
            if(this.licenses.length > 0) {
              // Recupero la prima licenza che possiede una customizzazione
              const license = this.licenses
                  .find(l => l.config 
                      && l.config.tasks 
                      && l.config.tasks['set-place-flow']
                      && l.config.tasks['set-place-flow'].type !== '');
              if(license) {
                const type = license.config.tasks['set-place-flow'].type;
                if(type === 'function') {
                  this.$anm22[license.config.tasks['set-place-flow'].name](this);
                } else if(type === 'component') {
                  const componentPath = license.config.tasks['set-place-flow'].name;
                  this.customComponent = () => import("../../custom/" + componentPath);
                }
              }
            }
          })
          .catch(error => console.log(error));
        })
        .catch(error => {
        });
    },
    loadData() {
      Promise.all([
        this.$store.dispatch('contactPlaceAssocs/load', this.$vlf('contactPlaceAssocs')),
        this.$store.dispatch('workPlaceAssocs/load', this.$vlf('workPlaceAssocs')),
        this.$store.dispatch('places/load', this.$vlf('places'))
      ])
      .then(() => {
        this.$Progress.finish();
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });        
    }
  },
  created() {
    this.loading = true;
    this.loadData();
    this.$http.get('project/place?idProject='+this.$route.params.id)
      .then(response => {
        Promise.all([
          this.$store.dispatch('contactPlaceAssocs/update', {
              vlf: this.$vlf('contactPlaceAssocs'),
              objs: response.data.contactPlaceAssocs
          }),
          this.$store.dispatch('workPlaceAssocs/update', {
              vlf: this.$vlf('workPlaceAssocs'),
              objs: response.data.workPlaceAssocs
          }),
          this.$store.dispatch('places/update', {
              vlf: this.$vlf('places'),
              objs: response.data.places
          })
        ])
        .catch(error => console.log(error))
      })
      .catch(error => console.log(error));
  },
  components: {
    WGWorldPlaceContainer
  }
}
</script>

<style lang="scss" scoped>

</style>
